import { Button } from 'components/atoms';
import { PublicPage } from 'components/templates';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { PiPlus } from 'react-icons/pi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGetUserSource } from 'services/auth/source';
import { USER_SOURCE } from 'services/auth/types';

const ConfirmEmailSource = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const email = params.get('email') ?? '';
  const token = params.get('token')?.replaceAll(' ', '+') ?? '';

  const source = useGetUserSource(email);

  useEffect(() => {
    const nextParams = `?email=${email}&token=${token}`;

    if (source.data?.id === USER_SOURCE.local) {
      navigate(`setup-password${nextParams}`);
    }
    if (source.data?.id === USER_SOURCE.client) {
      navigate(`confirm${nextParams}`);
    }
    if (source.isError) {
      toast.error(t('error-code.USER_NOT_FOUND'));
      navigate('/login');
    }
  }, [source.data]);

  return (
    <PublicPage>
      <div className='scale-[2] mb-[125px] mt-[55px]'>
        <Button isClear isLoading onlyIcon>
          <PiPlus />
        </Button>
      </div>
    </PublicPage>
  );
};

export default ConfirmEmailSource;
